import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';

import { BaseTable, NoItemsPanel, PageContentPreloader } from 'common/components';
import noPaymentsImage from 'common/images/noPayments.svg';

import { getUserTotalPSPs } from '../../_redux/actions';

const UserTotalPSPs = ({ getUserTotalPSPs, totalPSPs, totalPSPsAreLoaded }) => {
  const { id } = useParams();

  useEffect(() => {
    getUserTotalPSPs({ id });
  }, [getUserTotalPSPs]);

  /* eslint-disable */
  const columns = [
    {
      key: 'justPS',
      Cell: ({ original: { paymentSystemSlug } }) => <div>{paymentSystemSlug}</div>,
    },
    {
      key: 'justDepositsTotal',
      Cell: ({ original: { totalDeposits } }) => <div>{totalDeposits ? `${totalDeposits} USD` : '---'}</div>,
    },
    {
      key: 'justWithdrawalsTotal',
      Cell: ({ original: { totalWithdrawals } }) => <div>{totalWithdrawals ? `${totalWithdrawals} USD` : '---'}</div>,
    },
  ];
  /* eslint-enable */

  return (
    <PageContentPreloader ready={totalPSPsAreLoaded} type="smallLines" firstLaunchOnly>
      <div className="UserTotalPSPs">
        {totalPSPs.length > 0 ? (
          <BaseTable data={totalPSPs} columns={columns} />
        ) : (
          <NoItemsPanel icon={noPaymentsImage} captionSlug="noPaymentsYet" />
        )}
      </div>
    </PageContentPreloader>
  );
};

UserTotalPSPs.propTypes = {
  getUserTotalPSPs: PropTypes.func.isRequired,
  totalPSPs: PropTypes.array,
  totalPSPsAreLoaded: PropTypes.bool,
};

UserTotalPSPs.defaultProps = {
  totalPSPs: [],
  totalPSPsAreLoaded: false,
};

export default compose(
  connect(
    state => ({
      totalPSPs: state.backoffice.users.totalPSPs,
      totalPSPsAreLoaded: state.backoffice.users.totalPSPsAreLoaded,
    }),
    {
      getUserTotalPSPs: data => getUserTotalPSPs.request(data),
    }
  )
)(UserTotalPSPs);
